<template>
  <transition appear mode="out-in" :name="expandDirection">
    <slot />
  </transition>
</template>

<script>
export default {
  name: "TransitionExpandSide",
  props: {
    expandDirection: {
      default: 'expand-side-left',
    }
  }
}
</script>

<style lang="scss">
.expand-side-left-enter-active,
.expand-side-left-leave-active,
.expand-side-right-enter-active,
.expand-side-right-leave-active {
  transition-duration: .5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(.55, 0, .1, 1);
  overflow: hidden;
}


.expand-side-right-enter,
.expand-side-right-leave-active {
  opacity: 0;
  transform: translate(-2em, 0);
}

.expand-side-left-enter,
.expand-side-left-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}
</style>
